const isValidProofApprovalContext: (context: string) => boolean = (
  context: string
) => ['Customer', 'CustomerCare', 'PrePress'].includes(context);

export default isValidProofApprovalContext;
